import React, { useEffect } from "react";
import { OrderedListOutlined, BorderOutlined, CheckSquareOutlined } from "@ant-design/icons";
import { Button, Input, Modal, Table, DatePicker, Form } from "antd";
import { useModel } from "../../../models";
import { DICT_KEY, getDictNameByCode } from "../../../utils/constants";

const OPT_TYPE = {
    ADD: 1,
    REMOVE: 2
}

export default function () {
    const [form] = Form.useForm();

    const [{
        formData, addMaterialModelVisible, documentMaterialList,
        materialList, materialPageInfo, materialSearchParam, selectedMaterialList
    }, {
        setAddMaterialModelVisible, loadSaleData, loadSaleDataAll,
        transSelectedSoItemListToRoItemList, addSelectedMaterial, setSelectedMaterialList,
        removeSelectedMaterial,
    }] = useModel("saleRo");

    const { pageSize, } = materialPageInfo;
    const { customerId } = formData;
    const customerName = getDictNameByCode(DICT_KEY.CM_DICT.CUSTOMER, customerId);

    useEffect(() => {
        setSelectedMaterialList([]);
        if (addMaterialModelVisible && customerId) {
            loadSaleData({
                showMsg: false,
                data: {
                    customerId,
                    customerName,
                    pageNum: 1,
                    pageSize
                }
            });
        }
    }, [addMaterialModelVisible]);

    const onOk = async () => {
        //将已选库存配件添加到订单商品明细里
        transSelectedSoItemListToRoItemList();
        setSelectedMaterialList([]);
        //关闭窗口
        setAddMaterialModelVisible(false);
    }
    const onClose = () => {
        setAddMaterialModelVisible(false);
    }

    const onSearch = () => {

        const searchParam = form.getFieldsValue();
        const [startTime = null, endTime = null] = !!searchParam["startEndTime"] ? searchParam["startEndTime"] : [];
        const { saleCode, materialCodeOrName } = searchParam;
        loadSaleData({
            showMsg: false,
            data: {
                customerId,
                customerName,
                pageSize,
                pageNum: 1,
                saleCode,
                materialCodeOrName,
                startTime,
                endTime
            }
        });
    }

    //全选
    const onCheckAll = () => {
        const searchParam = form.getFieldsValue();
        const [startTime = null, endTime = null] = !!searchParam["startEndTime"] ? searchParam["startEndTime"] : [];
        const { saleCode, materialCodeOrName } = searchParam;
        loadSaleDataAll({
            showMsg: false,
            data: {
                customerId,
                customerName,
                pageSize: 999999,
                pageNum: 1,
                saleCode,
                materialCodeOrName,
                startTime,
                endTime
            }
        });
    }

    const onAdd = (record) => {
        // console.log(record)
        addSelectedMaterial(record);
    }
    const onRemove = (record) => {
        removeSelectedMaterial(record);
    }
    const Title = () => {
        return (

            <h3 style={{ flex: "1" }}>
                <OrderedListOutlined />
                <span className="margin-left-8">销售退货单-选择配件</span>
            </h3>

        )
    }
    const columns = (optType) => [
        {
            title: '序号',
            dataIndex: 'code',
            width: 50,
            render: (text, record, index) => index + 1,
        },
        {
            title: '销售单号',
            width: 140,
            dataIndex: 'saleCode',
            align: 'left',
        },
        {
            title: '制单日期',
            width: 100,
            dataIndex: 'createTime',
            align: 'left',
            render: text => text ? text.split(" ")[0] : ""
        },
        {
            title: '客户',
            width: 140,
            ellipsis: true,
            dataIndex: 'customerName',
            render: () => customerName
        },
        {
            title: '商品编号',
            width: 140,
            dataIndex: 'materialCode',
            align: 'left',
        },
        {
            title: '商品名称',
            width: 180,
            ellipsis: true,
            dataIndex: 'materialName',
        },
        {
            title: '图号',
            width: 120,
            dataIndex: 'replaceNum',
        },
        {
            title: '单位',
            width: 80,
            dataIndex: 'materialUnit',
        },
        {
            title: '销售数量',
            width: 80,
            dataIndex: 'saleNum',
        },
        {
            title: '赠品数量',
            width: 80,
            dataIndex: 'giftsNum',
        },
        {
            title: '已退数量',
            width: 80,
            dataIndex: 'returnNum',
        },

        {
            title: '业务员',
            width: 100,
            ellipsis: true,
            dataIndex: 'createUser',
        },
        {
            title: '操作',
            width: 80,
            fixed: 'right',
            render: (text, record) => (
                optType === OPT_TYPE.ADD ? (<Button
                    type="link"
                    htmlType="button"
                    className="margin-left-8"
                    size="small"
                    disabled={
                        !!selectedMaterialList.find(el => el.detailedId === record.detailedId)
                        || !!documentMaterialList.find(el => !!el.detailedId && el.detailedId === record.detailedId)
                        || record.saleNum <= record.returnNum
                    }
                    onClick={() => onAdd(record)}
                >
                    添加
                </Button>) : (<Button
                    type="link"
                    htmlType="button"
                    className="margin-left-8"
                    size="small"
                    onClick={() => onRemove(record)}
                >
                    移除
                </Button>)),
        },
    ];
    const StockMaterialList = () => {
        return (
            <>
                <div style={{ margin: "0 0 8px", display: "flex" }}>
                    <h3 style={{ width: "550px", paddingTop: "6px" }}>
                        <BorderOutlined /> 待选配件列表
                    </h3>
                    <div className="detail-list-statistic">
                        <Form form={form} name="sale_item_search_form" layout="inline" onFinish={onSearch}>
                            <Form.Item
                                name="saleCode"
                            >
                                <Input
                                    placeholder="销售单号"
                                />
                            </Form.Item>
                            <Form.Item
                                name="materialCodeOrName"
                            >
                                <Input
                                    placeholder="请输入商品编号或商品名称"
                                />
                            </Form.Item>
                            <Form.Item
                                name="startEndTime"
                            >
                                <DatePicker.RangePicker placeholder="起止" />
                            </Form.Item>
                            <Form.Item shouldUpdate={true}>
                                <Button htmlType="submit" type="primary">查询</Button>
                                <Button type="checkAll" style={{ marginLeft: "5px" }} onClick={onCheckAll}>全选</Button>
                            </Form.Item>
                        </Form>
                    </div>

                </div>
                <Table
                    columns={columns(OPT_TYPE.ADD)}
                    dataSource={materialList}
                    bordered
                    pagination={{
                        // simple: true,
                        // size: "small",
                        // hideOnSinglePage: false,
                        // showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 50, 100, 200],
                        defaultCurrent: 1,
                        defaultPageSize: pageSize,
                        onChange: (pageNum, pageSize) => {
                            const searchParam = form.getFieldsValue();
                            const [startTime = null, endTime = null] = !!searchParam["startEndTime"] ? searchParam["startEndTime"] : [];
                            const { saleCode, materialCodeOrName } = searchParam;
                            const params = {
                                customerId,
                                customerName,
                                saleCode,
                                materialCodeOrName,
                                startTime,
                                endTime,
                                pageNum,
                                pageSize
                            };
                            /*params.pageNum = page;
                            params.pageSize = pageSize;*/
                            // console.log(params)
                            loadSaleData({ showMsg: false, data: params });
                        },
                        total: materialPageInfo.total,
                        current: materialPageInfo.pageNum,
                    }}
                    scroll={{ y: 220, x: 1900 }}
                />
            </>
        )
    }
    const SelectedStockMaterialList = () => {
        return (
            <>
                <div style={{ margin: "8px 0", display: "flex" }}>
                    <h3 style={{ width: "460px", paddingTop: "6px" }}>
                        <CheckSquareOutlined /> 已选配件列表
                    </h3>
                    <div className="detail-list-statistic" style={{ textAlign: "right" }}>

                    </div>
                </div>
                <Table
                    scroll={{ y: 220, x: 1300 }}
                    columns={columns(OPT_TYPE.REMOVE)}
                    dataSource={selectedMaterialList}
                    bordered
                    pagination={false}
                />
            </>
        )
    }
    return (
        <Modal
            title={<Title />}
            width={1366}
            visible={addMaterialModelVisible}
            onOk={onOk}
            onCancel={onClose}
        >
            <StockMaterialList />
            <SelectedStockMaterialList />
        </Modal>
    );
}